import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ManageCostObjLocations from "./ManageCostObjLocations";
import { fetchLocationTypes } from 'redux/costObjs/CostObjsActions';

const mapStateToProps = ({ costObjs }) => ({
  fetchingLocationTypes: costObjs.fetchingLocationTypes,
  locationTypes: costObjs.locationTypes,
});

const mapDispatchToProps = dispatch => ({
  costObjsActions: bindActionCreators({ fetchLocationTypes }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageCostObjLocations);




// WEBPACK FOOTER //
// ./src/components/manageCostObjs/comp/costObjEditor/ManageCostObjLocationsConnector.js